import { cn } from "../../../lib/cn";

/**
 * KpiCardSplit — variante del KpiCard con borde superior 3px en color
 * funcional y bloque inferior con dos sub-métricas.
 *
 * Uso:
 *   <KpiCardSplit
 *     label="Incidencias abiertas"
 *     value="24"
 *     topBorderClass="border-t-area-hardware-fg"
 *     splitA={{ label: "Críticas", value: "3" }}
 *     splitB={{ label: "Pendientes", value: "21" }}
 *   />
 */

export function KpiCardSplit({
  label,
  value,
  topBorderClass = "border-t-primary",
  splitA,
  splitB,
  className,
}) {
  return (
    <div className={cn(
      "bg-card border border-border rounded-lg overflow-hidden",
      "border-t-[3px]",
      topBorderClass,
      className,
    )}>
      <div className="p-4">
        <div className="text-[11px] uppercase tracking-wide text-slate-500 mb-1">
          {label}
        </div>
        <div className="text-2xl font-semibold text-slate-900">
          {value}
        </div>
      </div>
      {(splitA || splitB) && (
        <div className="grid grid-cols-2 border-t border-border text-xs">
          {splitA && (
            <div className="p-2.5 border-r border-border">
              <div className="text-slate-400 text-[10px] uppercase tracking-wide">
                {splitA.label}
              </div>
              <div className="text-slate-900 font-medium">{splitA.value}</div>
            </div>
          )}
          {splitB && (
            <div className="p-2.5">
              <div className="text-slate-400 text-[10px] uppercase tracking-wide">
                {splitB.label}
              </div>
              <div className="text-slate-900 font-medium">{splitB.value}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
